import { render, staticRenderFns } from "./185.vue?vue&type=template&id=167d6680&scoped=true&"
var script = {}
import style0 from "./185.vue?vue&type=style&index=0&id=167d6680&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167d6680",
  null
  
)

export default component.exports